import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './meeting-simple.types';
import * as constants from './meeting-simple.constants';

export const storeMeetingSimple = generateStoreResourceAction<types.IMeetingSimple>(constants.STORE_MEETING_SIMPLE);
export const clearMeetingSimple = generateClearResourceAction(constants.CLEAR_MEETING_SIMPLE);
